import * as types from './weaveFactorActionTypes';

export const getWeaveFactorRequestAction = (payload) => ({
  type: types.GET_WEAVEFACTOR_REQUEST,
  payload,
});

export const getWeaveFactorDataAction = (payload) => ({
  type: types.GET_WEAVEFACTOR_DATA,
  payload,
});

export const getWeaveFactorErrorAction = (payload) => ({
  type: types.GET_WEAVEFACTOR_ERROR,
  payload,
});

export const createWeaveFactorRequestAction = (payload) => ({
  type: types.CREATE_WEAVEFACTOR_REQUEST,
  payload,
});

export const createWeaveFactorDataAction = (payload) => ({
  type: types.CREATE_WEAVEFACTOR_DATA,
  payload,
});

export const createWeaveFactorErrorAction = (payload) => ({
  type: types.CREATE_WEAVEFACTOR_ERROR,
  payload,
});

export const updateWeaveFactorRequestAction = (payload) => ({
  type: types.UPDATE_WEAVEFACTOR_REQUEST,
  payload,
});

export const updateWeaveFactorDataAction = (payload) => ({
  type: types.UPDATE_WEAVEFACTOR_DATA,
  payload,
});

export const updateWeaveFactorErrorAction = (payload) => ({
  type: types.UPDATE_WEAVEFACTOR_ERROR,
  payload,
});

export const deleteWeaveFactorRequestAction = (payload) => ({
  type: types.DELETE_WEAVEFACTOR_REQUEST,
  payload,
});

export const deleteWeaveFactorDataAction = (payload) => ({
  type: types.DELETE_WEAVEFACTOR_DATA,
  payload,
});

export const deleteWeaveFactorErrorAction = (payload) => ({
  type: types.DELETE_WEAVEFACTOR_ERROR,
  payload,
});
